import { PageTab } from "../page-tab"

export class LockOverviewTab extends PageTab {
  readonly id = "overview"
  readonly label = "Lock"
  readonly hrefTemplate = "/lock"
}

export class LockCreateTab extends PageTab {
  readonly id = "create"
  readonly label = "Create"
  readonly hrefTemplate = "/lock/create"
}

export class LockExtendTab extends PageTab {
  readonly id = "extend"
  readonly label = "Extend"
  readonly hrefTemplate = "/lock/extend"
}

export class LockIncreaseTab extends PageTab {
  readonly id = "increase"
  readonly label = "Increase"
  readonly hrefTemplate = "/lock/increase"
}
